import { useEffect, useState } from 'react'
import {
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    TableHead,
    TableFooter,
    TablePagination
} from '@mui/material';

import Row from './Row';
import COLORS from '../styles/colors.json';

const DATA_TYPE_QUOTE = 'quote';

const COLUMNS = [
    { label: '' }, // EXPAND
    { label: '' }, //PDF
    { label: 'Date' },
    { label: 'Store', align: 'right' },
    { label: 'Document Number' },
    { label: 'Name' },
    { label: 'Customer ID' },
    { label: 'Vehicle' },
    { label: 'Mileage', align: 'right' },
    { label: 'License' },
    { label: 'Total', align: 'right' }
]


const EmptyRow = ({ dataType }) => {
    return (
        <TableRow >
            <TableCell colSpan={12} align="center">
                {`SEARCH FOR ${dataType.toUpperCase()}`}
            </TableCell>
        </TableRow>
    ) 
}

const ErrorRow = () => {
    return (
        <TableRow >
            <TableCell colSpan={12} align="center" sx={{ backgroundColor: COLORS.lsYellow }}>
                ERROR DURING SEARCH. PLEASE NARROW SEARCH CRITERIA
            </TableCell>
        </TableRow>
    )
}

const MaxDataRow = ({ limit }) => {
    return (
        <TableRow >
            <TableCell colSpan={12} align="center" sx={{ backgroundColor: COLORS.lsYellow }}>
                {`SEARCH RESULTS EXCEED ${limit} RECORDS. PLEASE NARROW YOUR SEARCH CRITERIA.`}
            </TableCell>
        </TableRow>
    )
}

const DataTable = (props) => {
    const {
        data=[],
        dataType,
        limit,
        features,
        error
    } = props;

    console.log({dataType}, {data})

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        setPage(0);
    }, [dataType, data])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const sliceData = () => {
        const rowStart = page * rowsPerPage;
        const rowEnd = page * rowsPerPage + rowsPerPage; 
        return data.slice(rowStart, rowEnd);
    }

    const buildRows = (rowCount) => {
        const builtRows = sliceData().map((row, index) => (
            <Row
                row={row}
                dataType={dataType}
                dataTablePage={page}
                index={index}
                features={features}
            />
        ));

        if (rowCount === limit) {
            builtRows.unshift(<MaxDataRow limit={limit}/>);
        }

        return builtRows;
    }

    const renderRows = () => {
        if (error) {
            return <ErrorRow />;
        }
        if (data.length === 0) {
            return <EmptyRow dataType={dataType}/>;
        }
        return buildRows(data.length);
    }

    const buildColumns = () => {
        return COLUMNS.map(({ label, align }) => {
            if (dataType === DATA_TYPE_QUOTE && label === 'Total') {
                return;
            }
            
            return (
                <TableCell
                    key={label}
                    align={align}
                    sx={{
                        fontWeight: 600,
                        color: COLORS.white
                    }}
                >
                    {label}
                </TableCell>
            )
        })
    }

    return (
        <TableContainer
            sx={{
                borderLeft: '1px solid #EEEEEE',
                borderRight: '1px solid #EEEEEE'
            }}
        >
            <Table sx={{ minWidth: 500 }}>
            
                <TableHead>
                    <TableRow sx={{ backgroundColor: COLORS.redDarker }}>
                        {buildColumns()}
                    </TableRow>
                </TableHead>
                
                <TableBody>
                    {renderRows()}
                </TableBody>
                
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableRow>
                </TableFooter>
            
            </Table>
        </TableContainer>
    );
}

export default DataTable;